let lastIndices = null;
const pathCache = {};

export const getPathList = (indices, currentId, level = 1) => {
    if (!indices) return [];
    if (lastIndices !== indices) {
        Object.keys(pathCache).forEach(k => delete pathCache[k]);
        lastIndices = indices;
    }
    const cacheKey = `${currentId}-${level}`;
    if (pathCache[cacheKey]) {
        return pathCache[cacheKey];
    }
    const pathList = [];
    const hasNode = (node, targetId) => {
        if (!node) return false;
        if (node.id === targetId) return true;
        if (node.nodes) {
            return node.nodes.some(child => hasNode(child, targetId));
        }
        return false;
    };
    const traverse = (nodes) => {
        if (!nodes) return false;
        for (const node of nodes) {
            const isOpen = (node.id === currentId) || hasNode(node, currentId);
            if (isOpen) {
                traverse(node.nodes);
                if (node.Level > level) {
                    pathList.push(node);
                }
                return true;
            }
        }
        return false;
    };
    traverse(indices);
    const result = [...pathList].reverse();
    pathCache[cacheKey] = result;
    return result;
};

export const getFullIndexPath = (indices, currentId) => {
    if (!indices || !currentId) return [];

    const targetStr = String(currentId);
    const rootNodes = Array.isArray(indices) ? indices : (indices.nodes || []);
    if (!rootNodes || !rootNodes.length) return [];

    const findChain = (nodes, chain) => {
        if (!nodes || !Array.isArray(nodes)) return null;
        for (const node of nodes) {
            if (!node) continue;
            const nextChain = [...chain, node];
            if (String(node.id) === targetStr) {
                return nextChain;
            }
            if (node.nodes && Array.isArray(node.nodes) && node.nodes.length > 0) {
                const found = findChain(node.nodes, nextChain);
                if (found) return found;
            }
        }
        return null;
    };

    return findChain(rootNodes, []) || [];
};

